import { Container } from "reactstrap";

const Reports = () => {
  return (
    <Container
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: "500px" }}
    >
      <p
        className="text-center"
        style={{ fontWeight: "bold", color: "gray", fontSize: "20px" }}
      >
        Reports
      </p>
    </Container>
  );
};
export default Reports;
